import React from "react";
import { ChevronDown, LogOut, User, Settings as SettingsIcon } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Avatar, AvatarFallback } from "./ui/avatar";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function UserMenu({ user }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const name = user?.name || "Keith";
  const initials = name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="inline-flex items-center gap-2 h-10 rounded-lg border border-primary bg-primary/5 hover:bg-primary/10 px-2 sm:pr-3 outline-none focus-visible:ring-2 focus-visible:ring-primary/40" data-testid="user-menu-trigger">
        <Avatar className="h-7 w-7">
          <AvatarFallback className="bg-primary text-primary-foreground text-[11px] font-semibold">{initials}</AvatarFallback>
        </Avatar>
        <span className="hidden sm:inline text-[13px] font-medium text-foreground whitespace-nowrap">{name}</span>
        <ChevronDown className="hidden sm:inline w-4 h-4 text-muted-foreground" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          <div className="text-sm font-medium">{name}</div>
          <div className="text-xs text-muted-foreground">{user?.email || "keith@unitedcloud.ca"}</div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate("/settings")}> <User className="w-4 h-4 mr-2" /> Profile</DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate("/settings")}> <SettingsIcon className="w-4 h-4 mr-2" /> Settings</DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={logout} className="text-destructive focus:text-destructive"> <LogOut className="w-4 h-4 mr-2" /> Sign out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
